// The document's degree-for-experience rule, as a table.
//
// The parser stores it the way it read it — the source table's cells joined with
// pipes, one line per row — because the substitutions are prose with conditions
// in them ("Bachelor's plus two years' work-related experience", "1 Year College
// = 1 Year Work") and a structure that dropped the conditions would be worse
// than the sentence. That is the right thing to STORE and the wrong thing to
// SHOW: rendered raw it reads as a developer's console output, which is what
// Shiraz saw.
//
// So it is stored faithfully and displayed as what it is. The parse here is
// deliberately dumb — split on the pipes the writer put in — and falls back to
// showing the text when a line does not fit the shape, because a document that
// writes its rule some other way must still be readable rather than mangled into
// a grid.
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function parseRows(text) {
    return text.split('\n').map((line)=>line.split('|').map((cell)=>cell.trim())).filter((cells)=>cells.some(Boolean));
}
export function EquivalencyTable({ text }) {
    const rows = parseRows(text);
    const [header, ...body] = rows;
    // One column means the writer used no pipes — this is a sentence, not a grid.
    // Shown as the sentence it is instead of a one-column table.
    if (!header || header.length < 2 || body.length === 0) {
        return /*#__PURE__*/ _jsx("p", {
            className: "whitespace-pre-wrap text-[length:var(--fs-ui-caption)] text-foreground",
            children: text
        });
    }
    return(// Scrolls in its own container: the substitution column is a paragraph wide
    // and the page body must never scroll sideways.
    /*#__PURE__*/ _jsx("div", {
        className: "overflow-x-auto",
        children: /*#__PURE__*/ _jsxs("table", {
            className: "w-full border-collapse text-left text-[length:var(--fs-ui-caption)]",
            children: [
                /*#__PURE__*/ _jsx("thead", {
                    children: /*#__PURE__*/ _jsx("tr", {
                        children: header.map((cell)=>/*#__PURE__*/ _jsx("th", {
                                className: "border-b border-border px-2 py-1.5 font-medium uppercase tracking-[0.06em] text-muted-foreground",
                                scope: "col",
                                children: cell
                            }, cell))
                    })
                }),
                /*#__PURE__*/ _jsx("tbody", {
                    children: body.map((cells)=>// The first cell is the education level being substituted FOR, which
                        // is what a reader scans down.
                        /*#__PURE__*/ _jsx("tr", {
                            children: cells.map((cell, i)=>/*#__PURE__*/ _jsx("td", {
                                    className: i === 0 ? 'whitespace-nowrap border-b border-border/60 px-2 py-1.5 align-top font-medium text-foreground' : 'border-b border-border/60 px-2 py-1.5 align-top text-muted-foreground',
                                    children: cell || '—'
                                }, `${cells[0]}-${i}`))
                        }, cells.join('|')))
                })
            ]
        })
    }));
}
